import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Game, { ISkin } from '../../views/game/Game'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import viewSelector from '../../redux/selectors/game/viewSelector'

import withTransition from '../../hoc/Transition'
import withRendererFilter from '../../hoc/RendererFilter'
import questionActions from '../../redux/actions/questionActions'
import { IGameActivity } from '../../helpers/data/question'
import { ISize } from '../../helpers/data/size'
import { IPlayerData } from '../../helpers/data/player'
import { IMountainPlayerData } from '../../helpers/data/mountainPlayer'
import { IMountainSortedPlayer } from '../../helpers/data/mountainSortedPlayer'
import viewTypes from '../../helpers/enums/views'
import { IStore } from '../../redux/reducers/index'
import appActions from '../../redux/actions/appActions'
import { IAccessibilityStore } from '../../redux/reducers/accessibilityReducer'

interface IGameProps {
	answerSelected: (selectedAnswersIDs: string[], time: number, playerUid: string) => void
	isFinished: boolean
	playerData: IPlayerData
	players: IMountainPlayerData[]
	activity: IGameActivity
	totalActivities: number
	totalTime: number
	size: ISize
	elapsedTime: number
	skin: ISkin
	gameMode: number
	isPauseEnabledSetting: boolean
	isTimerDisabledSetting: number
	audioUpdate: () => void
	isSoundEnabledSetting: boolean
	volume: number
	isMuted: boolean
	accessibility: IAccessibilityStore
	currentPlayerRank: number
	sortedPlayers: IMountainSortedPlayer[]
	areAnimationsEnabled: boolean
	animationsToggleUpdate: (enabled: boolean) => void
}

class GameConnector extends PureComponent<IGameProps> {
	render() {
		return (
			<Game
				answerSelected={this.props.answerSelected}
				players={this.props.players}
				activity={this.props.activity}
				totalActivities={this.props.totalActivities}
				totalTime={this.props.totalTime}
				elapsedTime={this.props.elapsedTime}
				isFinished={this.props.isFinished}
				playerData={this.props.playerData}
				size={this.props.size}
				skin={this.props.skin}
				gameMode={this.props.gameMode}
				isPauseEnabledSetting={this.props.isPauseEnabledSetting}
				isTimerDisabledSetting={this.props.isTimerDisabledSetting}
				audioUpdate={this.props.audioUpdate}
				isSoundEnabledSetting={this.props.isSoundEnabledSetting}
				volume={this.props.volume}
				isMuted={this.props.isMuted}
				accessibility={this.props.accessibility}
				currentPlayerRank={this.props.currentPlayerRank}
				sortedPlayers={this.props.sortedPlayers}
				areAnimationsEnabled={this.props.areAnimationsEnabled}
				animationsToggleUpdate={this.props.animationsToggleUpdate}
			/>
		)
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			answerSelected: questionActions.answerSelected,
			audioUpdate: appActions.audioUpdate,
			animationsToggleUpdate: appActions.animationsToggleUpdate,
		},
		dispatch
	)
}

const mapStateToProps = (state: IStore) => {
	return {
		...viewSelector(state),
		accessibility: state.accessibility,
	}
}

export default withTransition(
	connect(mapStateToProps, mapDispatchToProps)(withRendererFilter(GameConnector, viewTypes.GAME))
)
